// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"f5d8f0b4","626":"7b05999b","759":"0e4d61e5"}[chunkId] + ".chunk.css";
};